import { Link } from 'react-router-dom';

export interface Activity {
  id: string;
  title: string;
  summary: string;
  category: string;
  reward: string;
  difficulty: string;
  hot: boolean;
  deadline: string;
  participants: string;
  tags: string[];
  image: string;
}

const difficultyMap: Record<string, string> = {
  轻松: 'bg-secondary-100 text-secondary-800',
  中等: 'bg-accent-100 text-accent-800',
  挑战: 'bg-primary-100 text-primary-800',
};

export default function ActivityCard({ activity }: { activity: Activity }) {
  return (
    <article className="group h-full flex flex-col bg-background-100 border border-background-200 rounded-2xl overflow-hidden transition-colors duration-300 hover:border-primary-300">
      <Link to={`/activities/${activity.id}`} className="block relative w-full h-44 md:h-48 overflow-hidden cursor-pointer">
        <img
          src={activity.image}
          alt={`${activity.title} 活动示意图`}
          title={`${activity.title} - 爆瓜福利活动`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {activity.hot && (
          <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
            <i className="ri-fire-line"></i>
            热门
          </span>
        )}
        <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs">
          {activity.participants} 人参与
        </span>
      </Link>

      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`px-2.5 py-1 rounded-full text-xs ${difficultyMap[activity.difficulty] || 'bg-background-100 text-foreground-700'}`}>
            {activity.difficulty}
          </span>
          {activity.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2.5 py-1 rounded-full bg-background-100 text-foreground-600 text-xs">
              {tag}
            </span>
          ))}
        </div>

        <h3 className="mt-3 text-base md:text-lg text-foreground-950 leading-snug">
          <Link to={`/activities/${activity.id}`} className="hover:text-primary-700 transition-colors cursor-pointer">
            {activity.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{activity.summary}</p>

        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[11px] text-foreground-500">奖励</p>
            <p className="text-sm font-medium text-primary-700 truncate">{activity.reward}</p>
          </div>
          <Link
            to={`/activities/${activity.id}`}
            className="shrink-0 inline-flex items-center gap-1 px-4 py-2 rounded-full bg-background-100 text-foreground-800 text-sm whitespace-nowrap hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
          >
            看规则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}